<template>
  <div>
    <div v-if="isLoading" class="isLoading">
      <div class="loading-box">
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'App',
    computed: {
      ...mapState({
        isLoading: state => state.base.isLoading
      })
    },
    created() {
      let isMobile = ua => {
        return !!ua.match(/AppleWebKit.*Mobile.*/)
      }
      let userAgent = navigator.userAgent
      if (isMobile(userAgent)) {
        window.location.href = 'https://zhaopin.4sjob.com/'
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue